import { Component, OnInit } from '@angular/core';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Essentials, MsgType } from '../../util/essentials';
import { Blockade } from '../../model/blockade';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'proceed-alert',
  templateUrl: './proceed-alert.component.html',
  styleUrls: ['./proceed-alert.component.css']
})
export class ProceedAlertComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<ProceedAlertComponent>, private translate: TranslateService) {
  }

  public alerts: string[] = [];

  ngOnInit(): void {
  }

  onProceedClick() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  };

}
